import React, { useEffect, useState } from "react";
import { Col, Dropdown, DropdownMenu, DropdownToggle, Row } from "reactstrap";
import SimpleBar from "simplebar-react";

import { SIGNALR_MESSAGE_TYPES } from "@/constants/signalrMessageTypes";

import {
  DoctorEnrollmentViewDetails,
  PatientEnrollmentViewDetails,
  PrescriptionRequestViewDetails
} from "@/pages/Globo/Transactions/TransactionsViewDetails";

import { AccessRequestViewDetails } from "@/pages/Security/TransactionsViewDetails";

import useCustomHook from "../Hooks/useCustomHook";
import { useSignalRListener } from "../Hooks/useSignalRListener";
import NotificationData from "./NotificationData";

import { useCountUnReadNotificationsQuery } from "@/api/Endpoints/Core/Socials/Notifications";

const NOTIFICATION_TYPES = {
  CORE_TRANSACTIONS_ACCESSREQUESTS: "CORE_TRANSACTIONS_ACCESSREQUESTS",

  GLOBO_TRANSACTIONS_DOCTORENROLLMENTS: "GLOBO_TRANSACTIONS_DOCTORENROLLMENTS",
  GLOBO_TRANSACTIONS_PATIENTENROLLMENTS: "GLOBO_TRANSACTIONS_PATIENTENROLLMENTS",
  GLOBO_TRANSACTIONS_PRESCRIPTION: "GLOBO_TRANSACTIONS_PRESCRIPTION",
};

const NotificationDropdown = () => {
  const { state, customFunction } = useCustomHook();
  const [badgeCount, setBadgeCount] = useState(0);
  const [isNotificationDropdown, setIsNotificationDropdown] = useState(false);

  const { data } = useCountUnReadNotificationsQuery();
  const notificationCount = data?.returnData;

  useEffect(() => {
    if (notificationCount) setBadgeCount(notificationCount);
  }, [notificationCount]);

  useSignalRListener({
    type: SIGNALR_MESSAGE_TYPES.NOTIFICATION,
    handler: () => {
      setBadgeCount(badgeCount + 1);
    },
  });

  const toggleNotificationDropdown = (data) => {
    setIsNotificationDropdown(!isNotificationDropdown);
  };

  const handleClickNotification = (data) => {
    const notificationType = data.notificationType;

    const toggleMap = {
      [NOTIFICATION_TYPES.CORE_TRANSACTIONS_ACCESSREQUESTS]: "toggleViewAccessRequest",

      [NOTIFICATION_TYPES.GLOBO_TRANSACTIONS_DOCTORENROLLMENTS]: "toggleViewDoctorEnrollments",
      [NOTIFICATION_TYPES.GLOBO_TRANSACTIONS_PATIENTENROLLMENTS]: "toggleViewPatientEnrollments",
      [NOTIFICATION_TYPES.GLOBO_TRANSACTIONS_PRESCRIPTION]: "toggleViewPrescription",
    };

    if (toggleMap[notificationType]) return customFunction.updateToggle(toggleMap[notificationType], data);
  };

  const handleViewAllNotification = () => {
    customFunction.updateToggle("toggleViewAllNotification");
  };

  return (
    <React.Fragment>

      <AccessRequestViewDetails
        data={{ accessRequestId: state.trxValue?.referenceId }}
        show={state?.toggle?.toggleViewAccessRequest}
        onCloseClick={() => customFunction.updateToggle("toggleViewAccessRequest")}
        parentKey={1}
        onUpdateParentKey={() => { }}
      />

      <DoctorEnrollmentViewDetails
        data={{ doctorEnrollmentId: state.trxValue?.referenceId }}
        show={state?.toggle?.toggleViewDoctorEnrollments}
        onCloseClick={() => customFunction.updateToggle("toggleViewDoctorEnrollments")}
        parentKey={1}
        onUpdateParentKey={() => { }}
      />

      <PatientEnrollmentViewDetails
        data={{ patientEnrollmentId: state.trxValue?.referenceId }}
        show={state?.toggle?.toggleViewPatientEnrollments}
        onCloseClick={() => customFunction.updateToggle("toggleViewPatientEnrollments")}
        parentKey={1}
        onUpdateParentKey={() => { }}
      />

      <PrescriptionRequestViewDetails
        data={{ prescriptionRequestId: state.trxValue?.referenceId }}
        show={state?.toggle?.toggleViewPrescription}
        onCloseClick={() => customFunction.updateToggle("toggleViewPrescription")}
        parentKey={1}
        onUpdateParentKey={() => { }}
      />

      <Dropdown isOpen={isNotificationDropdown} toggle={toggleNotificationDropdown} className="topbar-head-dropdown ms-1 header-item">
        <DropdownToggle type="button" tag="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle">
          <i className="bx bx-bell fs-22"></i>
          {badgeCount > 0 ? (
            <span className="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger">
              {badgeCount}
              <span className="visually-hidden">unread messages</span>
            </span>
          ) : null}
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
          <div className="dropdown-head bg-primary bg-pattern rounded-top">
            <div className="p-3">
              <Row className="align-items-center">
                <Col>
                  <h6 className="m-0 fs-16 fw-semibold text-white"> Notifications </h6>
                </Col>
                {badgeCount > 0 ? (
                  <div className="col-auto dropdown-tabs">
                    <span className="badge bg-danger text-white fs-13">{badgeCount}</span>
                  </div>
                ) : null}
              </Row>
            </div>
          </div>

          <SimpleBar style={{ maxHeight: "300px" }} className="pe-2">
            {isNotificationDropdown && <NotificationData onClickNotification={handleClickNotification} />}

            <div className="my-3 text-center">
              <button onClick={handleViewAllNotification} type="button" className="btn btn-soft-success waves-effect waves-light">
                View All Notifications <i className="ri-arrow-right-line align-middle"></i>
              </button>
            </div>
          </SimpleBar>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default NotificationDropdown;
